import HeroSection from "./HeroSection";
import WhySell from "./WhySell";
import FAQs from "../Home/FAQs";
import Title from "../title";
import ProductListing from "./ProductListing";

function Seller() {
	return (
		<>
			<Title title = "Seller"/>
			<div>
				<HeroSection />

				<WhySell />

				<ProductListing />

				{/* <SupplierFeedback /> */}

				<div className="live-deals --align" style={{ paddingTop: 50, paddingBottom: 60, minHeight : 696 }}>
					<h1 className='text-2xl text-theme-blue pb-[30px] lg:text-4xl' >Frequently Asked Questions (FAQs)</h1>
					<FAQs />
				</div>
			</div>
		</>
	)
}

Seller.SellerLayout = (page: any) => {
	return(
		{page}
	)
}

export default Seller